import withFeatureBranch from '@wix/da-react-context/pkg/flags/withFeatureBranch';
import ShopCommissionsControls from './ShopCommissionsControls';
import ShopCommissionsControlsContainer from './ShopCommissionsControls.container';
import ShopCommissionsControlsContainerrBranched from './ShopCommissionsControls.deviation_gruser.container';

export default withFeatureBranch({
  gruser_shop: ShopCommissionsControlsContainerrBranched(
    ShopCommissionsControls
  ),
})(ShopCommissionsControlsContainer(ShopCommissionsControls));
